// External
import join from 'url-join';

// Internal
import { asyncAction } from '~APP_UTIL/actions';
import http from '~APP_UTIL/http';
import { handleError } from '../../util';
import actionTypes from './actionTypes';

// Constants
const api2 = join(import.meta.env.VITE_API2_URL, 'v1');
export const normalizeResponseHeaders = files =>
  files.map(({ status, ...rest }) => {
    if (status === 'SUCCESS') {
      return {
        ...rest,
        status,
        success: true
      };
    }
    return {
      ...rest,
      status,
      success: false
    };
  });

export const submitHeaders = asyncAction({
  baseName: actionTypes.SUBMIT_CATALOG_HEADERS,
  action: action => files => dispatch => {
    dispatch(action.start());

    const formData = new FormData();

    for (let i = 0; i < files.length; i++) {
      formData.append('catalogs', files[i]);
    }

    return http
      .postFiles(join(api2, '/catalogs/createFromExcel'), formData)
      .then(async ({ data }) => {
        dispatch(action.success());
        return normalizeResponseHeaders(data?.results || []);
      })
      .catch(error => {
        if (error.status !== 400) {
          return handleError(dispatch, action, error);
        }
        return error;
      });
  }
});

export default {
  submitHeaders
};
